import React from 'react'
import AboutEdit from './About/AboutEdit'
import PostData from './Languages/Lang/siteText.json'
import Translation from './Translation'

const About2 = (props) => {
    const language = props.lang
    return (
        <>
        {language === "ESP" && <Translation />}
        
    {language === "PL" && <><AboutEdit
        title={PostData.map((postDetail, index) => {return postDetail.about1title})}
          grey={PostData.map((postDetail, index) => {return postDetail.about1grey})}
          text={PostData.map((postDetail, index) => {return postDetail.about1text})}
            url={PostData.map((postDetail, index) => {return postDetail.about1url})}
        orientation={true} />
    <AboutEdit
        title={PostData.map((postDetail, index) => {return postDetail.about2title})}
          grey={PostData.map((postDetail, index) => {return postDetail.about2grey})}
          text={PostData.map((postDetail, index) => {return postDetail.about2text})}
            url={PostData.map((postDetail, index) => {return postDetail.about2url})}
            orientation={false} />
    <AboutEdit
        title={PostData.map((postDetail, index) => {return postDetail.about3title})}
         grey={PostData.map((postDetail, index) => {return postDetail.about3grey})}
         text={PostData.map((postDetail, index) => {return postDetail.about3text})}
          url={PostData.map((postDetail, index) => {return postDetail.about3url})}
            orientation={true} /></>}



{language === "ENG" && <><AboutEdit
        title={PostData.map((postDetail, index) => {return postDetail.about1titleENG})}
          grey={PostData.map((postDetail, index) => {return postDetail.about1greyENG})}
          text={PostData.map((postDetail, index) => {return postDetail.about1textENG})}
            url={PostData.map((postDetail, index) => {return postDetail.about1urlENG})}
        orientation={true} />
    <AboutEdit
        title={PostData.map((postDetail, index) => {return postDetail.about2titleENG})}
          grey={PostData.map((postDetail, index) => {return postDetail.about2greyENG})}
          text={PostData.map((postDetail, index) => {return postDetail.about2textENG})}
            url={PostData.map((postDetail, index) => {return postDetail.about2urlENG})}
            orientation={false} />
    <AboutEdit
        title={PostData.map((postDetail, index) => {return postDetail.about3titleENG})}
         grey={PostData.map((postDetail, index) => {return postDetail.about3greyENG})}
         text={PostData.map((postDetail, index) => {return postDetail.about3textENG})}
          url={PostData.map((postDetail, index) => {return postDetail.about3urlENG})}
            orientation={true} /></>}



{language === "GER" && <><AboutEdit
        title={PostData.map((postDetail, index) => {return postDetail.about1titleGER})}
          grey={PostData.map((postDetail, index) => {return postDetail.about1greyGER})}
          text={PostData.map((postDetail, index) => {return postDetail.about1textGER})}
            url={PostData.map((postDetail, index) => {return postDetail.about1url})}
        orientation={true} />
    <AboutEdit
        title={PostData.map((postDetail, index) => {return postDetail.about2titleGER})}
          grey={PostData.map((postDetail, index) => {return postDetail.about2greyGER})}
          text={PostData.map((postDetail, index) => {return postDetail.about2textGER})}
            url={PostData.map((postDetail, index) => {return postDetail.about2urlGER})}
            orientation={false} />
    <AboutEdit
        title={PostData.map((postDetail, index) => {return postDetail.about3titleGER})}
         grey={PostData.map((postDetail, index) => {return postDetail.about3greyGER})}
         text={PostData.map((postDetail, index) => {return postDetail.about3textGER})}
          url={PostData.map((postDetail, index) => {return postDetail.about3urlGER})}
            orientation={true} /></>}


             
        </>
    )
}

export default About2
